module.exports = __webpack_public_path__ + "c53e33c764e139d11e3caf9e940cad06.svg";